const screenHeight = state => state.app.screenHeight;
const screenWidth = state => state.app.screenWidth;
const windowScrollY = state => state.app.windowScrollY;

const language = state => state.app.language;
const translation = state => state.app.translation;

const headerView = state => state.app.headerView;

const displayLoader = state => state.app.displayLoader;
const displayModal = state => state.app.displayModal;
const displayMenu = state => state.app.displayMenu;
const displayProfile = state => state.app.displayProfile;

const refCode = state => state.app.refCode;

export default {
  screenHeight,
  screenWidth,
  windowScrollY,

  language,
  translation,

  headerView,

  displayLoader,
  displayModal,
  displayMenu,
  displayProfile,

  refCode,
};
